import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ButtonToolbar, Dropdown, MenuItem } from 'react-bootstrap';

const {
  Toggle,
  Menu
} = Dropdown;

class PDropdown extends Component {
  constructor(props) {
    super(props);

    this.onHover = this.onHover.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onClickItem = this.onClickItem.bind(this);

    this.state = {
      isOpen: false,
      isHover: false,
    };
  }

  /**
   * Update isHover state
   * @param {*} value true or false
   */
  onHover(value) {
    if (value !== this.state.isHover) {
      this.setState({
        isHover: value
      });
    }
  }

  /**
   * Handle onClick action and disable hover
   * @param {*} item menu item
   */
  onClickItem(item, id) {
    if (item) {
      item.onClick(item.key, id);
      this.onHover(false);
    }
  }

  /**
   * Update isOpen state to open or close Toggle
   */
  onToggle() {
    const {
      disableOnToggle
    } = this.props;

    if (!disableOnToggle) {
      this.setState({
        isOpen: !this.state.isOpen,
      });
    }
  }

  /**
   * Render Toggle by props
   */
  renderToggle() {
    const {
      label,
      toggleContent,
      toggleClassName,
      noCaret
    } = this.props;

    if (!_.isNil(toggleContent)) {
      return (
        <Toggle
          bsStyle="default"
          noCaret={noCaret}
          className={toggleClassName}
          bsClass='dropdown'
        >
          {toggleContent}
        </Toggle>
      );
    }

    return (
      <Toggle
        bsStyle="default"
        noCaret={noCaret}
        className={toggleClassName}
      >
        <span>{label}</span>
        <i className="fa icon dropdown-arrow"></i>
      </Toggle>
    );
  }

  /**
   * Create menu item by props
   */
  makeMenuItem(item) {
    const className = `menu-item ${item.className || ''} ${item.isSelected ? 'selected' : ''}`;
    return (
      <MenuItem
        key={item.key}
        className={className}
        onClick={() => this.onClickItem(item, this.props.id)}
      >
        {item.children}
      </MenuItem>
    );
  }

  /**
   * Render menu item by props
   */
  renderMenuItem() {
    const {
      menuItems,
      menuItemsClassName = '',
    } = this.props;

    const menuItemsConfig = _.map(
      _.filter(menuItems, config => !config.predicate), (menuItem) =>
        [
          this.makeMenuItem(menuItem),
          !_.isNil(menuItem.isDivider) && menuItem.isDivider === false ? null : <div className='divider'></div>,
        ],
    );

    return (
      <Menu
        className={menuItemsClassName}
      >
        {menuItemsConfig}
      </Menu>
    );
  }

  render() {
    const {
      id,
      className,
      disabled
    } = this.props;

    return (
      <ButtonToolbar>
        <Dropdown 
          id={id}
          className={`${this.state.isHover ? 'hover' : ''} ${className}`}
          open={this.state.isOpen}
          onToggle={this.onToggle}
          onMouseEnter={() => this.onHover(true)}
          onClick={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
          disabled={disabled}
        >
          {this.renderToggle()}
          {this.renderMenuItem()}
        </Dropdown>
      </ButtonToolbar>
    );
  }
}

PDropdown.propTypes = {
  id:  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  label: PropTypes.string,
  noCaret: PropTypes.bool,
  menuItems: PropTypes.array,
  disableOnToggle: PropTypes.bool,
  disabled: PropTypes.bool,
};

PDropdown.defaultProps = {
  noCaret: true,
  disableOnToggle: false,
  label: '',
  className: '',
};

export default PDropdown;



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Dropdown.js